
<div  class="val-barre-navigation val-couleur-fond val-flex-conteneur val-flex-colonne"
      [class.ouvert]="ouvert"
      [class.ferme]="!ouvert"
      [style.--largeur]="largeur + 'px'">
  @if (navigationItems.length > 0) 
  {
    @for (navigationItem of navigationItems; track $index) 
    {
      <val-barre-navigation-item  [donneesItem]="navigationItem"
                                  [barreNavigation]="this">
      </val-barre-navigation-item>
    }
  }
  @if (urlApiManifest)
  {
    <val-barre-navigation-version #version [urlApiManifest]="urlApiManifest"
                                           [masquerReleaseNotes]="masquerReleaseNotes">
    </val-barre-navigation-version>
  }
</div>

